var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleDoubleLeftBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.78125 4.75L8.4375 1.125C8.59375 0.96875 8.84375 0.96875 8.96875 1.125L9.21875 1.34375C9.34375 1.5 9.34375 1.71875 9.21875 1.875L6 5L9.1875 8.15625C9.34375 8.3125 9.34375 8.53125 9.1875 8.6875L8.96875 8.90625C8.84375 9.0625 8.59375 9.0625 8.4375 8.90625L4.78125 5.28125C4.625 5.125 4.625 4.90625 4.78125 4.75ZM0.78125 5.28125C0.625 5.125 0.625 4.90625 0.78125 4.75L4.4375 1.125C4.59375 0.96875 4.84375 0.96875 4.96875 1.125L5.1875 1.34375C5.34375 1.5 5.34375 1.71875 5.1875 1.875L2 5L5.21875 8.15625C5.34375 8.3125 5.34375 8.53125 5.21875 8.6875L4.96875 8.90625C4.84375 9.0625 4.59375 9.0625 4.4375 8.90625L0.78125 5.28125Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDoubleLeftBlack);
export default __webpack_public_path__ + "static/media/angle-double-left-black.ae5e82ae.svg";
export { ForwardRef as ReactComponent };